// 在线字典
import request from "@/services/axios";
import { url } from "@/services/api";
// const url = "http://192.168.88.140:15001"

export default {
  // 分页列表查询
  getOnlineDictPage(params) {
    return request({
      url: url + "/system/onlDict/list",
      method: "get",
      params: params
    });
  },
  // 下拉列表查询
  getOnlineDictList(params) {
    return request({
      url: url + "/system/onlDict/selectList",
      method: "get",
      params: params
    });
  },
  // 获取在线表单字典详细信息
  getOnlineDictInfo(params) {
    return request({
      url: url + "/system/onlDict/" + params.id,
      method: "get"
    });
  },

  // 获取在线字典选择列表
  getOnlineDictQueryOneList(params) {
    return request({
      url: url + "/system/onlDict/getSelectDict/" + params.dictType,
      method: "get"
    });
  },

  // 新增在线表单字典
  AddOnlDict(data) {
    return request({
      url: url + "/system/onlDict",
      method: "post",
      data: data
    });
  },
  // 修改在线表单字典
  UpdateOnlDict(data) {
    return request({
      url: url + "/system/onlDict",
      method: "put",
      data: data
    });
  },
  // 修改在线表单字典
  DelOnlDict(data) {
    return request({
      url: url + "/system/onlDict/" + data.id,
      method: "delete"
    });
  }
};
